import bidiFactory from 'bidi-js';
import { RLO, PDF, LRO } from '../constant';
/**
 * 判断文本方向是 rtl
 * @returns
 */
export function isRtl(element) {
    if (!document) {
        return false;
    }
    if (!element) {
        return document.documentElement.getAttribute('dir') === 'rtl';
    }
    while (element && element.parentNode instanceof HTMLElement) {
        if (element.getAttribute('dir') === 'rtl') {
            return true;
        }
        element = element.parentNode;
    }
    return false;
}
export function getBidiType(str) {
    if (!str)
        return 3;
    var filterList = ['L', 'EN', 'ES', 'ET', 'AN', 'CS'];
    var bidi = bidiFactory();
    var embeddingObj = bidi.getEmbeddingLevels(str);
    var levels = Array.from(embeddingObj.levels);
    function isEven(val, index) {
        // const charTypeName = bidi.getBidiCharTypeName(str[Number(index)]);
        // if(filterList.includes(charTypeName)) return true;
        if (str[Number(index)] === '')
            return true;
        return Number(val) % 2 === 0;
    }
    function isOdd(val, index) {
        // const charTypeName = bidi.getBidiCharTypeName(str[Number(index)]);
        // if(filterList.includes(charTypeName)) return true;
        if (str[Number(index)] === '')
            return true;
        return Number(val) % 2 !== 0;
    }
    if (levels.every(isEven))
        return 0;
    if (levels.every(isOdd))
        return 1;
    return 2;
}
export function isRtlText(str) {
    if (str === void 0) { str = ''; }
    var filterList = ['L', 'EN', 'ES', 'ET', 'AN', 'CS'];
    var bidi = bidiFactory();
    var embeddingObj = bidi.getEmbeddingLevels(str);
    var levels = Array.from(embeddingObj.levels);
    function isEven(val, index) {
        if (str[Number(index)] === '')
            return true;
        return Number(val) % 2 === 0;
    }
    function isOdd(val, index) {
        if (str[Number(index)] === '')
            return true;
        return Number(val) % 2 !== 0;
    }
    if (levels.every(isEven))
        return true;
    if (levels.every(isOdd))
        return false;
    return false;
}
/**
 * 判断当前语言是否是 RTL
 * ar 阿拉伯语
 * fa 波斯语
 * ur 乌尔都语
 * he 希伯来语
 * @param locale
 * @returns
 */
export function isRtlLocale(locale) {
    if (locale === void 0) { locale = ''; }
    var rtlReg = /^(ar|fa|ur|he)/;
    return rtlReg.test(locale);
}
/**
 * 设置文档的文本方向为 RTL
 */
export function setRtl() {
    if (document) {
        document.documentElement.setAttribute('dir', 'rtl');
    }
}
/**
 *
 * @param str 需要双向算法处理的字符串
 * @returns 双向算法处理之后的字符串
 */
export function unicodeWrap(str, direction) {
    if (!str)
        return '';
    if (!direction) {
        direction = isRtl() ? 'rtl' : 'ltr';
    }
    var finalStr = isRtl() ? unicodeRtl(str) : unicodeLtr(str);
    return finalStr;
    // return str;
}
/**
 *
 * @param str 需要设置成RTL的字符串
 */
export function unicodeRtl(str) {
    return RLO + str + PDF;
}
/**
 *
 * @param str 需要设置成LTR的字符串
 */
export function unicodeLtr(str) {
    return LRO + str + PDF;
}
